import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import "./Login.css";

const Login = () => {
    const { login } = useContext(AuthContext);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);
        
        try {
            await login(username, password);
            navigate("/dashboard");
        } catch (err) {
            console.error("登入失敗:", err);
            setError("登入失敗，請檢查您的用戶名和密碼。");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-header">
                <h2>歡迎回來</h2>
                <p>請登入您的帳號以繼續</p>
            </div>

            <form className="login-form" onSubmit={handleSubmit}>
                <div className="input-group">
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="用戶名"
                        required
                        disabled={isLoading}
                    />
                </div>
                
                <div className="input-group">
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="密碼"
                        required
                        disabled={isLoading}
                    />
                </div>

                {error && <p className="error-message">{error}</p>}

                <button 
                    type="submit" 
                    className="login-btn"
                    disabled={isLoading}
                >
                    {isLoading ? "登入中..." : "🔐 登入"}
                </button>
            </form>

            <div className="login-footer">
                <p>
                    還沒有帳號？{" "}
                    <Link to="/register" className="register-link">
                        立即註冊
                    </Link>
                </p>
            </div>
        </div>
    );
};

export default Login;